import { createContext, useContext, useLayoutEffect, useRef,  } from 'react'

import { localAccessors } from '@utils/localStateAccess'
import usePostStatsContext from './postStatsContext'
import useCheckButton from '@hooks/useCheckButton'
import useFeed from '@hooks/useFeed'

const ForYouFeedContext = createContext();
const ForYouFeedProvider = ({ children }) => {
  const { forYouFeed } = localAccessors
  const postStats = usePostStatsContext()
  const firstProviderRender = useRef(true)

  //// FOR YOU FEED CONFIG
  const forYouFeedRef = useRef()
  // Feed State/Utilities
  const forYouFeedState = useFeed({ getPostsUrl: '/api/feeds/for_you_posts', feedAccessor: forYouFeed(), postStats })
  // CheckPostButton state
  const forYouCheckPostsButton = useCheckButton({ getDataOnClick: forYouFeedState.getPosts, ignoreNewPostsCheck: true })

  // sets timeout for check posts button on initial render
  useLayoutEffect(() => {
    if (firstProviderRender.current) {
      forYouCheckPostsButton.setCheckPostsTimeout(10000)
      firstProviderRender.current = false
    }
  }, [])

  return (
    <ForYouFeedContext.Provider value={{
      feedRef: forYouFeedRef,
      feedState: forYouFeedState,
      checkPostsButton: forYouCheckPostsButton,
    }}>
      {children}
    </ForYouFeedContext.Provider>
  )
}

const useForYouFeedContext = () => useContext(ForYouFeedContext)

export default useForYouFeedContext

export { ForYouFeedContext, ForYouFeedProvider, useForYouFeedContext }
